import { Processor } from '../../../shared/types/processors.type';
import { Label } from '../../autoLabels/types/label';
import { Pipeline } from '../../ecg/types/ecg.type';
import { Metric } from '../../metric/types/metric.type';

export const EMPTY_COMMENT = '--';
export type Modifier =
  | 'likelihood'
  | 'temporality'
  | 'frequency'
  | 'localization';
export type Likelihood = 'possible' | 'probable' | 'confirmed' | null;
export type Frequency = 'intermittent' | null;
export type Temporality =
  | 'unique'
  | 'frequent'
  | 'doublet'
  | 'triplet'
  | 'bigeminy'
  | null;
export type Localization =
  | 'septal'
  | 'anterior'
  | 'antero-septal'
  | 'lateral'
  | 'inferior'
  | 'frontal'
  | 'precordial'
  | 'widespread'
  | 'other'
  | 'infero-lateral'
  | 'infero-basal'
  | null;

export interface Abnormality {
  code: string;
  name: string;
  likelihood: Likelihood;
  frequency: Frequency;
  temporality: Temporality;
  localization: Localization;
  category?: string;
}

export interface ServerAbnormality {
  code: string;
  name: string;
  likelihood: Likelihood;
  frequency: Frequency;
  temporality: Temporality;
  localization: Localization;
}

export interface Diagnostic {
  annotationTable: string;
  comment: string;
  expertName: string;
  expertRole: string;
  expertId: string;
  id: number;
  updatedAt: string;
  abnormalities: Abnormality[];
  pipeline: Pipeline;
  suggestionsLogs: Record<string, AutoLabelsLogs> | null;
}

export interface AutoLabelsLogs {
  labelsToAdd?: Label[];
  labelsToRemove?: Label[];
  abnormalities?: Abnormality[];
}

export interface ServerAutoLabelsLogs {
  labelsToAdd: Label[];
  labelsToRemove: Label[];
  abnormalities: Abnormality[];
}

export interface ServerAnnotatorComment {
  autoLabelsLogs?: Record<string, ServerAutoLabelsLogs> | null;
  computedMetrics?: Metric[];
}

export interface ServerReportParameters {
  annotator_comment: ServerAnnotatorComment;
}

export interface ServerDiagnostic {
  comment: string | null;
  coding_table: string | null;
  created_at: string;
  updated_at: string;
  expert_name: string;
  expert_role: string;
  expert_uuid: string;
  id: number;
  abnormalities: ServerAbnormality[];
  pipeline: Pipeline;
  report_parameters: ServerReportParameters | null;
}

export interface ServerDefinition {
  category_code: string;
  abnormalities: Definition[];
  categories: ServerDefinition[];
}

export interface Definition {
  category?: string;
  code: string;
  name: string;
  subcategory?: string;
  likelihood: string[] | null;
  frequency: string[] | null;
  temporality: string[] | null;
  localization: string[] | null;
}

export type DiagnosticProcessor = Processor<Diagnostic>;
